import { render, staticRenderFns } from "./usersDetail.vue?vue&type=template&id=7cb8000a&scoped=true"
import script from "./usersDetail.vue?vue&type=script&lang=js"
export * from "./usersDetail.vue?vue&type=script&lang=js"
import style0 from "./usersDetail.vue?vue&type=style&index=0&id=7cb8000a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb8000a",
  null
  
)

export default component.exports